var _path, _tspan;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74.668,
    height: 74.857,
    viewBox: "0 0 70 70.179",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0h30L0 70.179v-30z",
    fill: "#2cbe4e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-45 -701.555 -290.594)",
    x: -440.349,
    y: 454.882,
    fontFamily: "sans-serif",
    fontSize: 50,
    letterSpacing: 0,
    wordSpacing: 0,
    style: {
      lineHeight: "125%"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -440.349,
    y: 454.882,
    fill: "#fff",
    fontSize: 13.75,
    fontWeight: "bold"
  }, "PROMO"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.6b8d486456667bab11566a752cb4b1f0.svg";
export { ForwardRef as ReactComponent };